import "./kendo.data.js";
import "./kendo.userevents.js";
import "./kendo.tooltip.js";
import "./kendo.mobile.scroller.js";
import "./kendo.draganddrop.js";
import "./kendo.dataviz.core.js";
import "./dataviz/map/location.js";
import "./dataviz/map/attribution.js";
import "./dataviz/map/navigator.js";
import "./dataviz/map/zoom.js";
import "./dataviz/map/crs.js";
import "./dataviz/map/layers/base.js";
import "./dataviz/map/layers/shape.js";
import "./dataviz/map/layers/bubble.js";
import "./dataviz/map/layers/tile.js";
import "./dataviz/map/layers/bing.js";
import "./dataviz/map/layers/marker.js";
import "./dataviz/map/main.js";

    export const __meta__ = {
        id: "dataviz.map",
        name: "Map",
        category: "dataviz",
        description: "The Kendo DataViz Map displays spatial data",
        depends: [ "data", "userevents", "tooltip", "dataviz.core", "drawing", "mobile.scroller" ]
    };

    export default kendo;